/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */


const ChevronRight = ({ className, width = "25", height = "24" }: { className?: string, width?: string, height?: string }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.91 6.00024L9.5 7.41024L14.08 12.0002L9.5 16.5902L10.91 18.0002L16.91 12.0002L10.91 6.00024Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronRight;
